import type { FaireProductEntity } from "../../entity_types/product";

export const p_zf6edrrmfr: FaireProductEntity = {
  token: "p_zf6edrrmfr",
  type: "product",
  name: "7 Chakra  Reiki set (in a beautifully handcrafted Box)",
  brandToken: "b_raqzmc7tej",
  brandName: "AmazeU",
  imageUrl: "https://cdn.faire.com/fastly/320328aa8b9f369c06f55a82099d138efd8a3285e371c9daa2c5557bc8420824.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9ee54e5f6d3d4484f9c55d6cefc68ee40f7c9abfab32a3e4a8d38c49309d9749.jpeg",
    "https://cdn.faire.com/fastly/b68491965ed25d148b1417592220f7f566253cb05b4399279e4d6de62dd2eb94.jpeg",
    "https://cdn.faire.com/fastly/442ed5e1a8968b8033e0dad2d24754791932fc416dc1fabcf64ef1fbb3158d71.webp",
    "https://cdn.faire.com/fastly/53913c41538d437afc0adfdbd923bcc0f0eed07f57fbb6f9fd43afbea299679d.webp",
    "https://cdn.faire.com/fastly/22401616333c1a415f0064c706892957d61161f723a8e4f7b4f5a97ae970ddf3.jpeg"
  ],
  priceDollars: 18.71,
  description: "7 Stone Chakra Set Palm Stones Engraved Healing Stones Meditation Mindfulness Reiki Healing Chakra Crystal Stones\n==========================\nComes in a Box\nIn oval  and round shape\nStone size is approx. 3 cm\n=========================\nChakra stones have the healing ability, they are believed to unblock or stabilize the chakras in our body. Holding these stones in your palm have a strong healing property. The energies from these stones clear the place around and removes all negativity. These chakra stones are used in meditation, reiki, yoga, chakra healing and energy balancing.\nSet of 7 chakra stones-\n• Red jasper (Root Chakra)\n• Orange Aventurine (Sacral Chakra),\nYellow Aventurine (Solar Plexus), \n• Green Aventurine (Heart Chakra), \n• Lapis Lazuli (Throat Chakra), \n• Lolite (Third-eye Chakra), \n• Amethyst (Crown Chakra)\n\nNote: These are natural chakra stones, the colors and sizes won't be uniform.",
  tags: [],
  msrpDollars: 37.41,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:14.270Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
